import { z } from 'zod';

const transformNullToUndefined = <T>(value: T) => value ?? undefined;

export type SignerUser = z.infer<typeof signerUserSchema>;

export const signerUserSchema = z.object({
  fullName: z.string().nullable().transform(transformNullToUndefined),
  documentation: z.string().nullable().transform(transformNullToUndefined),
  birthday: z.string().nullable().transform(transformNullToUndefined),
});
